import { RouterProps, withRouter } from 'react-router';
import * as React from 'react';
import Footer from '../App/components/Layout/Footer/Footer';
import Header from '../App/components/Layout/Header/Header';
import MainNavigation from '../App/components/Layout/MainNavigation/MainNavigation';
import ContentFragmentContainer from '../App/modules/ContentFragment/containers/ContentFragment/ContentFragmentContainer';
import withRouteMetadata from '../App/hocs/withRouteMetadata';
import BaseRoute from './_BaseRoute';


class PrivacyInfoRoute extends BaseRoute {
	public static async getInitialProps (state: any) {
		const reduxData = await ContentFragmentProps(state, "afwebpwa_privacy_terms");

		return { reduxData };
	}

	public render () {

		return (
			<div>
				<Header />
				<MainNavigation />

				<ContentFragmentContainer
					fragmentKey="afwebpwa_privacy_terms"
					pageTitle="Datenschutz"
				/>

				<Footer />
			</div>
		);
	}
}

export default withRouter(
	withRouteMetadata(
		PrivacyInfoRoute,
		`privacyInfo`,
		{
			metaTitle: `Datenschutz | Aktionsfinder`,
			metaDescription: `Erfahren Sie alles über die Datenschutzbestimmungen der Aktionsfinder GmbH » Hier klicken und über alle Einzelheiten informieren.`,
		} as IRouteMetadataSetterType
	)
);
